import React from 'react'
import { Helmet } from 'react-helmet'
import ServicesSection from '../../components/ServicesSection'
import about from "../../assets/about.png"
import Layout from '../../components/layouts/Layout'

function Service() {
    return (
        <div>
            <div>
                <Helmet> <title>Kaanshi Films Entertainment (KFE) | Film & Video Production House Mumbai | Service Us Page</title> </Helmet>
                <Layout>
                    <div className="">
                        <img src={about} height={200} className='h-[500px] w-full  object-fill' alt="" />
                    </div>

                    <ServicesSection />

                </Layout>
            </div>
        </div>
    )
}

export default Service
